import { all, call, put, takeLatest } from 'redux-saga/effects';

import { constants } from '@nhl/formatter-utilities';

import { fetchEncodedData } from '../../../utility/requests';

import actionCreators from './actionCreators';
import actionTypes from './actionTypes';

function* getPPTData({ payload }) {
    try {
        const gameDataUrl = `${window.__BASE_REST_URL__}/game?cayenneExp=id=${payload.gameId}&include=gameFormat`;
        const teamDataUrl = `${window.__BASE_REST_URL__}/team?include=logos&include=teamColorways`;

        const [gameData, teamData] = yield all([
            call(fetchEncodedData, gameDataUrl),
            call(fetchEncodedData, teamDataUrl),
        ]);

        const game = gameData.data[0];

        yield put(actionCreators.gameDataResponse(true, null, gameData.data[0]));
        yield put(actionCreators.teamDataResponse(true, null, teamData.data));

        if (game.gameStateId >= constants.PREGAME) {
            const pptDataUrl = `${window.__PPT_BASE_URL__}/${gameData.data[0].season}/${payload.gameId}`;

            const [entityRegData, eventSummaryData, playerStatsData] = yield all([
                call(fetchEncodedData, `${pptDataUrl}/EntityRegistration.json`),
                call(fetchEncodedData, `${pptDataUrl}/LiveEventSummary.json`),
                call(fetchEncodedData, `${pptDataUrl}/PlayerStats.json`),
            ]);

            if (entityRegData[0] && eventSummaryData[0] && playerStatsData[0]) {
                const pptData = eventSummaryData[0].EntitySummaries.map((es) => {
                    const entity = entityRegData[0].Entities?.find((er) => er.EntityId === es.EntityId);
                    const stats = playerStatsData.find((ps) => ps.OfficialId === es.EntityOfficialId);

                    return {
                        ...es,
                        Entity: entity,
                        Stats: stats,
                    };
                }).filter((es) => es.EntityTeamId !== '' && es.Entity && es.Entity.EntityType !== 'Zamboni');

                yield put(actionCreators.pptDataResponse(true, null, pptData));
            }
        }
    } catch (errors) {
        yield put(actionCreators.gameDataResponse(false, errors, null));
    }
}

export default function* watchPPTData() {
    yield takeLatest(actionTypes.REQUEST_PPT_DATA, getPPTData);
}
